export var Paths;

(function (Paths) {
  Paths["ShowInterests"] = "/me/interests";
  Paths["UpdateInterests"] = "/me/interests";
})(Paths || (Paths = {}));